import create from 'zustand'
import { devtools } from 'zustand/middleware'
import axios from 'axios';
import produce from 'immer';
import Cookies from 'js-cookie'

const usePortfolioStore = create((set, get) => ({
    global: {},
    pairs: {}, 
    shortLong: {},
    exchanges: {},

    fetchGlobalPortfolio: async () => {
        const token = Cookies.get('token')
        try {    
        const res = await axios({
        headers: { Authorization: token },
        method: "GET",
        url:"/api/portfolio/fetch_global",
        timeout : 2000
        })
        set({global : await res.data})
        } catch (err) {
        console.log(err)
        }
    },
    fetchPairsPortfolio: async () => {
        const token = Cookies.get('token')
        try {    
        const res = await axios({
        headers: { Authorization: token },
        method: "GET",
        url:"/api/portfolio/fetch_pairs",
        timeout : 2000
        })
        set({pairs : await res.data})
        } catch (err) {
        console.log(err)
        }
    },
    fetchshortLongPortfolio: async () => {
        const token = Cookies.get('token')
        try {    
        const res = await axios({
        headers: { Authorization: token },
        method: "GET",
        url:"/api/portfolio/fetch_short_long",
        timeout : 2000
        })
        set({shortLong : await res.data})
        } catch (err) {
        console.log(err)
        }
    },
    fetchExchangesPortfolio: async () => {

        const token = Cookies.get('token')
        try {    
        const res = await axios({
        headers: { Authorization: token },
        method: "GET",
        url:"/api/portfolio/fetch_exchanges",
        timeout : 2000
        })
        set({exchanges : await res.data})
        } catch (err) {
        console.log(err)
        }
    },
}))


export default usePortfolioStore